import React from 'react';
import SiteGroupsPage from './Component';
import { CustomerType } from 'src/routes/Customers/modules/types';

type Props = {
  currentCustomer: CustomerType | null | undefined;
  horizontalLayout: boolean;
};
const SiteGroups = ({ currentCustomer, horizontalLayout }: Props) => {
  return (
    <SiteGroupsPage
      currentCustomer={currentCustomer}
      horizontalLayout={horizontalLayout}
    />
  );
};

export default SiteGroups;
